var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReciprocity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#005777",
    d: "M 238.5,19.5 C 330.486,15.5822 403.319,50.5822 457,124.5C 502.835,197.524 509.835,274.191 478,354.5C 440.256,434.218 377.756,481.384 290.5,496C 199.06,505.317 124.56,474.484 67,403.5C 17.5543,333.721 6.22098,258.055 33,176.5C 64.6504,96.5134 122.15,46.0134 205.5,25C 216.575,22.7308 227.575,20.8975 238.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 173.5,126.5 C 196.668,124.834 207.168,135.501 205,158.5C 203.667,161.167 202.333,163.833 201,166.5C 189.5,178 178,189.5 166.5,201C 248.5,201.333 330.5,201.667 412.5,202C 421.237,204.404 427.071,209.904 430,218.5C 432.765,233.474 427.265,243.974 413.5,250C 307.833,250.667 202.167,250.667 96.5,250C 80.4958,241.484 76.3291,228.984 84,212.5C 110.805,184.695 137.972,157.195 165.5,130C 168.158,128.522 170.825,127.355 173.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 98.5,285.5 C 203.501,285.333 308.501,285.5 413.5,286C 421.641,288.807 427.141,294.307 430,302.5C 431.612,310.734 430.279,318.4 426,325.5C 399.167,352.333 372.333,379.167 345.5,406C 343.5,407 341.5,408 339.5,409C 315.377,412.209 304.211,401.709 306,377.5C 307.333,374.833 308.667,372.167 310,369.5C 321.5,358 333,346.5 344.5,335C 261.833,334.667 179.167,334.333 96.5,334C 83.4767,327.453 78.3101,316.953 81,302.5C 84.1436,293.853 89.9769,288.187 98.5,285.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReciprocity);
export default __webpack_public_path__ + "static/media/Reciprocity.84c25991b92d68cb86a426cdeedfa18a.svg";
export { ForwardRef as ReactComponent };